/*
|--------------------------------------------------------------------------
| Views: Featured Video Single
|--------------------------------------------------------------------------
*/

/**
 * Featured Video Single
 * @namespace
 */
__gh__webApp.views.featuredVideoSingle = {

	"getSubView": function(bucket){
		var thirdPartyData 	= __gh__coreData["3rdPartyData"],
			toutID			= thirdPartyData.video.tout.id;

		bucket.toutID		= toutID;
		bucket.view.name 	= "buckets/featuredVideoSingle/default";

		return bucket;
	}

};
